// @flow
import api from 'tim-api';
import { placesInGoals as placesInGoalsEndPoint } from 'endPoints';

export const state: Object = {
  places: [],
  pagination: {},
  place: {}
};

export const getters = {
  places: (state: Object) => state.places,
  getPlaceById: (state: Object) => (id: Number) => id && state.places.find(place => place.id.toString() === id.toString()),
  getPlaceInfo: (state: Object) => state.place,
  getPlaceByCustCode: (state: Object) => (custCode: String) => custCode && state.places.find(place => place.cust_code === custCode),
  pagination: (state: Object) => state.pagination,
  place: (state: Object) => state.place
};

export const mutations = {
  SET_PLACES(state: Object, places: Array<Object>) {
    state.places = places;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  },
  SET_PLACE(state: Object, payload: Object) {
    state.place = {
      ...state.place,
      ...payload
    };
  }
};

export const actions = {
  fetchPlaces({ commit }: Action, { page, search, sort }: Object) {
    commit('SET_PLACES', []);

    let url = search ? `places/?filter=${search}&page=${page || 1}` : `places?page=${page || 1}`;

    if (sort) {
      url += `&order=${sort.order}&sort=${sort.sort}`;
    }

    return api.get(`${url}`).then(({ data }) => {
      commit('SET_PLACES', data.data.data);
      commit('SET_PAGINATION', {
        current_page: data.data.current_page,
        first_page_url: data.data.first_page_url,
        from: data.data.from,
        last_page: data.data.last_page,
        last_page_url: data.data.last_page_url,
        next_page_url: data.data.next_page_url,
        path: data.data.path,
        per_page: data.data.per_page,
        prev_page_url: data.data.prev_page_url,
        total: data.data.total
      });
    });
  },

  fetchPlaceByCustCode({ commit }: Action, custCode: String) {
    return api.get('/places', custCode).then(({ data }) => {
      commit('SET_PLACES', data.data.data);
      commit('SET_PAGINATION', {});
    });
  },

  fetchFilterdPlaces({ commit }: Action, filter: string) {
    return api.get(`places?filter=${filter}`).then(({ data }) => {
      commit('SET_PLACES', data.data.data);
      commit('SET_PAGINATION', {
        current_page: data.data.current_page,
        first_page_url: data.data.first_page_url,
        from: data.data.from,
        last_page: data.data.last_page,
        last_page_url: data.data.last_page_url,
        next_page_url: data.data.next_page_url,
        path: data.data.path,
        per_page: data.data.per_page,
        prev_page_url: data.data.prev_page_url,
        total: data.data.total
      });
    });
  },

  fetchPlaceById({ commit }: Action, id: string) {
    return api.get(`${placesInGoalsEndPoint}${id}`).then(({ data }) => {
      commit('SET_PLACES', [data.data]);
    });
  },

  fetchPlaceInfo({ commit }: Action, id: string) {
    return api.get(`${placesInGoalsEndPoint}${id}`).then(({ data }) => {
      let view = '-';
      let place = data.data;
      place.views.forEach((item) => {
        if (item.parent == 2) {
          view = item;
        }
      });
      place.selected_view = view;
      commit('SET_PLACE', place);
    });
  },

  fetchPlacesByPage({ commit }: Action, pageIndex: number) {
    commit('SET_PLACES', []);
    return api.get(`places?paginate=true&page=${pageIndex}`).then(({ data }) => {
      commit('SET_PLACES', data.data.data);
    });
  },

  // eslint-disable-next-line
  updatePlace({ commit }: Action, payload: Object) {
    return api.put(`${placesInGoalsEndPoint}${payload.id}`, payload.body);
  },

  // eslint-disable-next-line
  updatePlaceStatus({ getters, commit }: Action, payload: Object) {
    return api.put(`${placesInGoalsEndPoint}${payload.id}`, payload.body)
      .then(({ data }) => {
        const newPlace = data.data;
        const index = getters.places.findIndex(item => item.id === newPlace.id);
        const { places } = getters;

        const newListPlaces = JSON.parse(JSON.stringify(places));
        newListPlaces.splice(index, 1, newPlace);

        commit('SET_PLACES', newListPlaces);
      });
  },

  // eslint-disable-next-line
  createPlace({ commit }: Action, payload: Object) {
    return api.post('goals/places', payload.body);
  },
  setPlace({ commit }: Action, payload: Object) {
    commit('SET_PLACE', payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
